import * as l from "react";
const a = (e) => /* @__PURE__ */ l.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ l.createElement(
    "mask",
    {
      id: "PF_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ l.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ l.createElement("g", { mask: "url(#PF_svg__a)" }, /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24h32V0H0z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ l.createElement(
    "mask",
    {
      id: "PF_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ l.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0v24h32V0H0z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ l.createElement("g", { mask: "url(#PF_svg__b)" }, /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v6h32V0H0zM0 18v6h32v-6H0z",
      fill: "#BF2714"
    }
  ), /* @__PURE__ */ l.createElement(
    "mask",
    {
      id: "PF_svg__c",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 10,
      y: 6,
      width: 12,
      height: 12
    },
    /* @__PURE__ */ l.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16 18a6 6 0 100-12 6 6 0 000 12z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ l.createElement("g", { mask: "url(#PF_svg__c)" }, /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.55 13.764a.197.197 0 01.286-.23l.373.217a.197.197 0 00.183.008l.922-.432a.197.197 0 01.199.019l.996.72 1.378-.742a.196.196 0 01.171-.008l1.038.451a.197.197 0 00.163-.003l.931-.448a.197.197 0 01.158-.006l1.152.46c.052.021.11.019.16-.006l.892-.441a.197.197 0 01.178.002l.819.428c.059.031.13.03.188-.003l.425-.24a.197.197 0 01.287.22l-.089.335H10.646l-.096-.3zM10.546 14.95a.197.197 0 01.29-.226l.34.205a.197.197 0 00.187.008l.877-.426a.197.197 0 01.204.02l.955.715 1.324-.739a.197.197 0 01.177-.007l.99.445a.197.197 0 00.168-.003l.888-.443a.197.197 0 01.163-.006l1.1.456c.053.022.114.02.165-.007l.85-.436a.197.197 0 01.183.002l.778.423c.06.033.134.031.194-.004l.39-.229a.197.197 0 01.29.219l-.085.329H10.637l-.091-.295zM10.741 15.737a.197.197 0 01.29-.227l.34.205a.197.197 0 00.187.008l.877-.426a.197.197 0 01.204.02l.956.715 1.323-.739a.197.197 0 01.177-.007l.99.445a.197.197 0 00.168-.003l.888-.443a.197.197 0 01.163-.006l1.1.456c.054.022.114.02.165-.007l.85-.435a.197.197 0 01.184.002l.777.422c.061.033.134.031.194-.004l.39-.229c.15-.088.334.05.29.219l-.084.329H10.832l-.09-.295zM11.923 16.524a.197.197 0 01.29-.227l.34.205a.197.197 0 00.187.008l.877-.426a.197.197 0 01.203.02l.957.715 1.323-.739a.197.197 0 01.177-.007l.99.445a.197.197 0 00.168-.003l.888-.443a.196.196 0 01.163-.005l1.1.455c.053.022.114.02.165-.007l.85-.435a.197.197 0 01.183.002l.778.422c.06.033.134.031.194-.003l.39-.23c.15-.088.333.05.29.219l-.085.33H12.014l-.091-.296zM10.349 17.507a.197.197 0 01.29-.226l.34.204a.197.197 0 00.186.009l.878-.426a.197.197 0 01.203.02l.956.714 1.324-.738a.197.197 0 01.177-.008l.99.446a.197.197 0 00.168-.003l.888-.443a.196.196 0 01.163-.006l1.1.455c.053.023.113.02.165-.006l.85-.436a.197.197 0 01.183.002l.778.422c.06.033.134.032.193-.003l.39-.23c.151-.088.334.05.29.22l-.084.328H10.44l-.091-.295z",
      fill: "#5277B9"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      d: "M14.423 14.138v1c-.844 0-1.441-.518-1.732-1.439l-.023-.15V9.446h1v4.023c.167.48.4.67.755.67zM17.192 14.138v1c.844 0 1.442-.518 1.732-1.439l.023-.15V9.446h-1v4.023c-.166.48-.4.67-.755.67z",
      fill: "red"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.725 6.909s-1.659-.434-1.659.666v3.462l1.934.574v-2.83s-.967-.59-.967-1.052c0-.462.692-.82.692-.82z",
      fill: "red"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      d: "M13.934 12.89l.63-.805M14.509 12.864l-.605-.81M14.838 12.89l.63-.805M15.413 12.864l-.604-.81M15.705 12.89l.63-.805M16.28 12.864l-.604-.81M16.61 12.89l.63-.805M17.184 12.864l-.604-.81M17.514 12.89l.63-.805M18.089 12.864l-.605-.81",
      stroke: "#000"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.455 7.094l1.197 2.339.147-2.339-.147-.46-1.197.46zm-.6 1.995l-.863-.914.862-1.028 1.813 2.898v.736l-.872-.736v-.956h-.94zm-1.898.705l1.573.753.123-1.163-1.31-1.12-.386 1.53zm1.651 1.931l-2.069-.211v-1.46l2.069.796v.875zm-2.124 1.433l-.246-1.24 2.332.116v1.124h-2.086zm3.284-2.038v-.7l.872.7-.095.37-.777-.37zm8.113.798l-.246 1.24H19.55v-1.124l2.332-.116zm-2.37-.193l2.07-.211v-1.46l-2.07.796v.875zm1.651-1.931l-1.573.753-.123-1.163 1.31-1.12.386 1.53zm-1.897-.705l.862-.914-.862-1.028-1.813 2.898v.736l.872-.736v-.956h.94zm-.6-1.995l-1.198 2.339-.147-2.339.147-.46 1.197.46zm-.313 4.026v-.7l-.873.7.095.37.778-.37z",
      fill: "#FA8F21"
    }
  ))))
), t = a;
export {
  t as default
};
